import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '最新路线', href: '/category/latest-routes' },
  { label: '访问教程', href: '/category/access-tutorials' },
  { label: '使用技巧', href: '/category/usage-tips' },
  { label: '常见问题', href: '/category/faq' },
  { label: '关于我们', href: '/about' },
];

const popularArticles = [
  { label: '2026年7月最新免费路线汇总', href: '/article/latest-route-2026-july' },
  { label: '手机端访问完整教程', href: '/article/mobile-access-tutorial' },
  { label: '备用路线使用指南', href: '/article/backup-routes-guide' },
  { label: '提升访问速度的5个技巧', href: '/article/speed-optimization-tips' },
  { label: '新手快速上手指南', href: '/article/newbie-quick-start' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-heart-line text-lg"></i>
                </span>
                <span className="text-lg font-semibold font-heading text-secondary-50">
                  爱情岛路线导航
                </span>
              </div>
              <p className="text-sm text-secondary-300 leading-relaxed">
                致力于为用户提供爱情岛一论坛最新免费路线入口、访问教程和使用技巧，持续更新，收藏备用不迷路。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-secondary-50 mb-4 font-heading">快速导航</h4>
              <ul className="space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-secondary-50 mb-4 font-heading">热门文章</h4>
              <ul className="space-y-2.5">
                {popularArticles.map((article) => (
                  <li key={article.href}>
                    <Link
                      to={article.href}
                      className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {article.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-secondary-50 mb-4 font-heading">免责声明</h4>
              <p className="text-sm text-secondary-300 leading-relaxed">
                本站仅提供论坛访问路线导航和教程信息，不存储任何论坛内容。路线信息仅供参考，请通过正规渠道访问。如有问题请联系我们。
              </p>
            </div>
          </div>

          <div className="border-t border-secondary-700/40 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-secondary-400">
              &copy; {currentYear} 爱情岛路线导航. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                关于我们
              </Link>
              <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                隐私政策
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}